import ReactWeekPicker from "components/ReactWeekPicker/ReactWeekPicker";
import CommonTooltip from "components/Tooltip/CommonTooltip";
import moment from "moment";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import LeftArrow_3 from "../../assets/img/icons/LeftArrow_3.svg";
import RightArrow_3 from "../../assets/img/icons/RightArrow_3.svg";
import AddSingleMemberDropdown from "../../components/CustomDropdown/AddSingleMemberDropdown";
import CreateProjectDropdown from "../../components/DropdownStyle/CreateProjectDropdown";
import DateRangePicker from "../../components/ReactDateRangePicker/ReactDateRangePicker";
import Select from "../../components/ReactSelectDropdown";
import ClearFilterButton from "../../components/Search/clearFilterButton";
import DatePicker from "../../components/SingleDatePicker/SingleDatePicker";
import { WhiteButton } from "../../styledComponents/buttons";
import {
  CommonFlex,
  CommonFlexIcon,
  FilterLabel,
  IconArrow,
  InputWithLabelSection,
} from "../../styledComponents/common";
import { FilterContainer } from "../../styledComponents/timesheet";

const TimesheetFilter = ({
  selectedOrganization,
  getOrganizationMembersList,
  organizationMembersList,
  selectedMember,
  selectMember,
  clearMember,
  selectedDate,
  onDateChange,
  //custom timeSheet
  startDate,
  endDate,
  dateLabel,
  onDateSelect,
  changeDateRange,
  //Office
  officeDetails,
  getOfficesShortList,
  officesShortList,
  selectedOffice,
  selectOffice,
  selectedOfficeMembers,
  page,
  selectedProject,
  selectProject,
  selectedTask,
  selectTask,
  selectLastWeek,
  selectCurrentWeek,
  selectLastMonth,
  selectTimezone,
  selectedTimezone,
  singleDateChange,
  singleDateChangeDaily,
  showWeekPickerFooter = true,
  selectToday,
  isTodaySelected,
  setIsTodaySelected,
  //for weekly
  selectPrevWeek,
  selectNextWeek,
  setSelectCurrentWeek,
  //for bi-weekly
  selectCurrentBiWeek,
  selectNextBiWeek,
  selectPrevBiWeek,
  showShadow,
}) => {
  const { t } = useTranslation();
  const orgType = selectedOrganization?.type || "operation";
  const isOperationType = orgType === "operation";
  const [officeOptions, setOfficeOptions] = useState([
    {
      label: `(${t("all_teams")})`,
      value: null,
    },
  ]);
  const [officeMembers, setOfficeMembers] = useState([]);

  useEffect(() => {
    if (selectedOfficeMembers) {
      selectedOfficeMembers(officeMembers);
    }
  }, [officeMembers]);

  useEffect(() => {
    if (isTodaySelected && moment(selectedDate).isBefore(moment(), "day")) {
      setIsTodaySelected(false);
    }
  }, [selectedDate, isTodaySelected, setIsTodaySelected]);

  useEffect(() => {
    if (selectedOrganization && selectedOrganization.id) {
      getOfficesShortList({ organization_id: selectedOrganization.id });
      getOrganizationMembersList({
        page: 1,
        organization_id: selectedOrganization.id,
        office_id: null,
      });
    }
  }, [selectedOrganization]);

  useEffect(() => {
    if (officeDetails) {
      const filteredMembers = organizationMembersList.filter(member => {
        return officeDetails.employees?.some(
          employee => employee.user.id === member.id,
        );
      });
      setOfficeMembers(filteredMembers);
    }
  }, [officeDetails]);

  useEffect(() => {
    if (officesShortList && officesShortList.length === 1) {
      getOrganizationMembersList({
        page: 1,
        organization_id: selectedOrganization.id,
        office_id: officesShortList[0].id,
      });
    }
    if (officesShortList && officesShortList.length > 1) {
      let newArr = [
        {
          label: `(${t("all_teams")})`,
          value: null,
        },
      ];
      officesShortList.forEach((office, i) => {
        newArr.push({
          label: office.name,
          value: office.id,
        });
      });
      setOfficeOptions(newArr);
    }
  }, [officesShortList]);

  useEffect(() => {
    if (
      selectedOffice &&
      selectedOffice.value &&
      officesShortList &&
      officesShortList.length > 1
    ) {
      getOrganizationMembersList({
        page: 1,
        organization_id: selectedOrganization.id,
        office_id: selectedOffice.value,
      });
    } else if (
      selectedOrganization?.id &&
      ((selectedOffice && selectedOffice.value === null) || !selectedOffice)
    ) {
      getOrganizationMembersList({
        page: 1,
        organization_id: selectedOrganization.id,
        office_id: null,
      });
    }
  }, [selectedOffice]);

  const onMemberSelect = person => {
    selectMember(person);
  };
  const isSelectedDateToday =
    selectedDate && moment(selectedDate).isSame(moment(), "day");

  return (
    <div>
      <FilterContainer
        marginTop="0px"
        showShadow={showShadow}
        admin={
          localStorage.getItem("selected_organization_role") === "admin" ||
          localStorage.getItem("selected_organization_role") === "owner"
        }
        isMonthly={page && page === "monthly"}
      >
        {(localStorage.getItem("selected_organization_role") === "admin" ||
          localStorage.getItem("selected_organization_role") === "owner") && (
          <>
            {isOperationType && (
              <InputWithLabelSection style={{ minWidth: `240px` }}>
              <FilterLabel>{t("team")}</FilterLabel>
              <Select
                isSearchable
                isClearable={selectedOffice?.value}
                value={selectedOffice}
                options={officeOptions}
                placeholder="Select Team..."
                onChange={e => {
                  e
                    ? selectOffice(e)
                    : selectOffice({
                        label: `(${t("all_teams")})`,
                        value: null,
                      });
                }}
                styles={CreateProjectDropdown()}
                components={{
                  IndicatorSeparator: () => null,
                  ClearIndicator: props => {
                    return <ClearFilterButton {...props} />;
                  },
                }}
                />
              </InputWithLabelSection>
            )}
            <InputWithLabelSection>
              <FilterLabel>{t("assignee")}</FilterLabel>
              <div style={{ width: `40px` }}>
                <AddSingleMemberDropdown
                  assigneeManage={selectedMember}
                  updateState={onMemberSelect}
                  membersList={
                    (selectedOffice &&
                      selectedOffice.label === "(All Teams)") ||
                    !selectedOffice
                      ? organizationMembersList
                      : officeMembers
                  }
                  clearAssignee={() => clearMember()}
                  closeDisabled={true}
                  page={page}
                />
              </div>
            </InputWithLabelSection>
          </>
        )}

        {page && (page === "weekly" || page === "biweekly") && (
          <CommonFlex gap="4px" alignItems="end">
            <InputWithLabelSection>
              <FilterLabel>
                {t("date_range")}
                {page === "weekly"
                  ? t(" (7 days selected)")
                  : t(" (14 days selected)")}
              </FilterLabel>
              <ReactWeekPicker
                startDate={startDate ? moment(startDate, "YYYY-MM-DD") : null}
                startDateId="report-date-range-start-date"
                endDate={endDate ? moment(endDate, "YYYY-MM-DD") : null}
                endDateId="report-date-range-end-date"
                onDatesChange={changeDateRange}
                onDateSelect={onDateSelect}
                selectLastWeek={selectLastWeek}
                selectCurrentWeek={selectCurrentWeek}
                showFooter={showWeekPickerFooter}
              />
            </InputWithLabelSection>

            {page === "weekly" && (
              <CommonFlexIcon gap="4px" margin="1.5px 0 0 0">
                {/* Prev week */}
                <CommonTooltip tooltipText={"Previous Week"}>
                  <IconArrow
                    onClick={selectPrevWeek}
                    padding="5px"
                    size="39px"
                    src={LeftArrow_3}
                  />
                </CommonTooltip>

                {/* Next week */}
                <CommonTooltip tooltipText={"Next Week"}>
                  <IconArrow
                    onClick={() => {
                      if (
                        endDate &&
                        moment(endDate, "YYYY-MM-DD").isSameOrAfter(
                          moment().endOf("week"),
                          "day",
                        )
                      ) {
                        return; // ignore click
                      }
                      selectNextWeek();
                    }}
                    disabled={
                      endDate &&
                      moment(endDate, "YYYY-MM-DD").isSameOrAfter(
                        moment().endOf("week"),
                        "day",
                      )
                    }
                    padding="5px"
                    size="39px"
                    src={RightArrow_3}
                  />
                </CommonTooltip>
              </CommonFlexIcon>
            )}

            {page === "biweekly" && (
              <CommonFlexIcon gap="4px" margin="1.5px 0 0 0">
                {/* Prev week */}
                <CommonTooltip tooltipText={"Previous Bi-Week"}>
                  <IconArrow
                    onClick={selectPrevBiWeek}
                    padding="5px"
                    size="39px"
                    src={LeftArrow_3}
                  />
                </CommonTooltip>
                {/* Next week */}
                <CommonTooltip tooltipText={"Next Bi-Week"}>
                  <IconArrow
                    onClick={
                      endDate &&
                      moment(endDate, "YYYY-MM-DD").isSameOrAfter(
                        moment().endOf("week"),
                        "day",
                      )
                        ? undefined // no click when disabled
                        : selectNextBiWeek
                    }
                    disabled={
                      endDate &&
                      moment(endDate, "YYYY-MM-DD").isSameOrAfter(
                        moment().endOf("week"),
                        "day",
                      )
                    }
                    padding="5px"
                    size="39px"
                    src={RightArrow_3}
                  />
                </CommonTooltip>
              </CommonFlexIcon>
            )}

            {page === "weekly" ? (
              <WhiteButton
                type="nav"
                style={{ height: "38px", padding: "0px 15px" }}
                onClick={setSelectCurrentWeek}
                borderRadius="6px"
              >
                This Week
              </WhiteButton>
            ) : (
              <WhiteButton
                type="nav"
                style={{ height: "38px", padding: "0px 15px" }}
                onClick={selectCurrentBiWeek}
                borderRadius="6px"
              >
                Latest 2 Weeks
              </WhiteButton>
            )}
          </CommonFlex>
        )}

        {page && page !== "monthly" && page === "daily" && (
          <CommonFlex disableResponsive gap="4px" alignItems="end">
            <InputWithLabelSection>
              <FilterLabel>
                {t("date")}{" "}
                {(isTodaySelected || isSelectedDateToday) &&
                  `(${t("Today selected")})`}
              </FilterLabel>
              <DatePicker
                id="createIssuedDate"
                date={selectedDate}
                onDateChange={onDateChange}
                placeholder={"Select date"}
                // allowPreviousDates
                disableCurrentAndFutureDates
                // disableFutureDates
                width="155px"
              />
            </InputWithLabelSection>
            <IconArrow
              onClick={() => {
                singleDateChangeDaily("left");
              }}
              padding="5px"
              size="39px"
              src={LeftArrow_3}
            />
            <IconArrow
              onClick={() => {
                moment(selectedDate).isBefore(moment().subtract(1, "day")) &&
                  singleDateChangeDaily("right");
              }}
              disabled={
                !moment(selectedDate).isBefore(moment().subtract(1, "day"))
              }
              padding="5px"
              size="39px"
              src={RightArrow_3}
            />
            <WhiteButton
              type="nav"
              style={{
                height: "38px",
                padding: "0px 15px",
              }}
              borderRadius="6px"
              onClick={selectToday}
            >
              Today
            </WhiteButton>
          </CommonFlex>
        )}

        {page && page === "custom" && (
          <CommonFlex gap="4px" alignItems="end">
            <InputWithLabelSection>
              <FilterLabel>
                {t("date_range")}
                {` (${dateLabel})`}
              </FilterLabel>
              <DateRangePicker
                startDate={startDate ? startDate : null}
                startDateId="custom-date-range-start-date"
                endDate={endDate ? endDate : null}
                endDateId="custom-date-range-end-date"
                onDatesChange={changeDateRange}
                onDateSelect={onDateSelect}
                selectLastWeek={selectLastWeek}
                selectLastMonth={selectLastMonth}
                selectNextWeek={selectNextWeek}
                disableFutureDates={false}
              />
            </InputWithLabelSection>
            <IconArrow
              onClick={() => {
                singleDateChange("left");
              }}
              padding="5px"
              size="39px"
              src={LeftArrow_3}
            />
            <IconArrow
              onClick={() => {
                moment(endDate).isBefore(moment().subtract(1, "day")) &&
                  singleDateChange("right");
              }}
              disabled={!moment(endDate).isBefore(moment().subtract(1, "day"))}
              padding="5px"
              size="39px"
              src={RightArrow_3}
            />
          </CommonFlex>
        )}
      </FilterContainer>
    </div>
  );
};

export default TimesheetFilter;
